import * as types from '../types';

const INITIAL_STATE = {
    firstName: '',
    lastName: '',
    birthdate: '2019-01-01',
    gender: '0',
    mobile: '',
    maritalStatus: '1',
    numOfChildren: '0',
    address: '',
    datePickerVisible: false,
    showMapView: false,
    mapRegion: {
        latitude: 31.9454,
        longitude: 35.9284,
        latitudeDelta: 0.0922,
        longitudeDelta: 0.0421
    },
    secondMapRegion: {
        latitude: 31.9454,
        longitude: 35.9284,
        latitudeDelta: 0.0922,
        longitudeDelta: 0.0421
    },
    userLocation: {
        latitude: 31.9454,
        longitude: 35.9284
    },
    secondUserLocation: {
        latitude: 31.9454,
        longitude: 35.9284
    },
    isSecondAddress: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.REGISTER_FIRST_UPDATE_STATE:
            return { ...state, ...action.payload };
        case types.REGISTER_FIRST_RESET_STATE:
            return INITIAL_STATE;
        case types.REGISTER_FIRST_SETUP_USER:
            const user = action.payload;
            const { FIRSTNAME, LASTNAME, BIRTHDATE, GENDER, MOBILE, ADDRESS } = user;
            return {
                ...state,
                firstName: FIRSTNAME,
                lastName: LASTNAME,
                birthdate: BIRTHDATE,
                gender: GENDER,
                mobile: MOBILE,
                address: ADDRESS
            };
        default:
            return state;
    }
};
